export const TIME_WINDOW_BUCKETS = [
  1000,            // 1s
  5000,            // 5s
  10000,           // 10s
  15000,           // 15s
  30000,           // 30s
  60000,           // 1m
  120000,          // 2m
  300000,          // 5m
  450000,          // 7.5m
  600000,          // 10m
  900000,          // 15m
  1800000,         // 30m
  3600000,         // 1h
  7200000,         // 2h
  18000000,        // 5h
  36000000,        // 10h
  43200000,        // 12h
  86400000,        // 1d
  604800000,       // 7d (1 week)
  2592000000,      // 30d (~1 month)
  5184000000,      // 60d (~2 months)
  7776000000,      // 90d (~3 months)
  10368000000,     // 120d (~4 months)
  15552000000,     // 180d (~6 months)
  18144000000,     // 210d (~7 months)
  20736000000,     // 240d (~8 months)
  23328000000,     // 270d (~9 months)
  25920000000,     // 300d (~10 months)
  28512000000,     // 330d (~11 months)
  31536000000      // 365d (~1 year)
];